import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import SchedulerCalendar from "../../../components/SchedulerCalendar";
import StickySidebar from "../../../components/StickySidebar";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "./../../../Scheduler.scss";
import schedulerStyles from "../../../Scheduler.module.scss";
import OfficeFilter from "../../../components/SchedulerFilters/OfficeFilter";
import { withTranslation } from "react-i18next";
import EmployeesFilter from "../../../components/SchedulerFilters/EmployeesFilter";
import styles from "./StaffAvailabilityTab.module.scss";
import constants from "../../../../../../constants";
import eventStyles from "../EventsShiftsTab/EventsShiftsTab.module.scss";
import StaffAvailabilityWeeklyView from "./StaffAvailabilityView/StaffAvailabilityWeeklyView";
import {
  getStaffMembersList,
  useAllActiveOffices,
  useGetOfficeAgendaMonthly,
} from "repositories/scheduler-repository";
import { getStorage, isMobileTab, setStorage } from "utils";
import MonthlyViewNew from "./StaffAvailabilityView/MonthlyViewNew";
import moment from "moment";
import CustomDropdown from "components/Dropdown";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import { cacheSideBarActive } from "utils";
import AgendaFilter from "accountOwner/pages/Scheduler/components/SchedulerFilters/AgendaFilter";
import DailyViewNew from "./StaffAvailabilityView/DailyViewNew";
import ExpandableSearchBar from "accountOwner/pages/AddEvent/SchedulingAssistant/components/ExpandableSearchBar";
import {
  filteringMethodForEventShiftOthers,
  leaveClasses,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import Text from "components/Text";
import WeeklyListView from "./StaffAvailabilityView/WeeklyListView";
import DailyListView from "./StaffAvailabilityView/DailyListView";

const reCalculate = ({
  containerHeight,
  allChildHeight,
  moreBoxHeight,
  lastEventHeight,
  cell,
}) => {
  if (containerHeight - allChildHeight - moreBoxHeight > lastEventHeight) {
    cell.maxVisibleEvents = cell.maxVisibleEvents + 1;
    reCalculate({
      containerHeight,
      allChildHeight: allChildHeight + lastEventHeight,
      moreBoxHeight,
      lastEventHeight,
      cell,
    });
  }
};

export const calculateMaxVisibleElements = ({
  cell,
  viewSettingFilter,
  checkForContinue,
  lastEventIndex,
  moreBoxIndex,
}) => {
  const allValues = cell;
  if (allValues.cell && allValues.seeMore && viewSettingFilter.length) {
    const cellElement = allValues.cell;
    const containerHeight = cellElement.clientHeight;
    const moreBoxHeight = cellElement.children[moreBoxIndex]?.offsetHeight || 0;
    const lastEventHeight =
      cellElement.children[lastEventIndex]?.offsetHeight || 0;
    let firstOrLast = -1;
    let allChildHeight = 0;
    let event = 0;
    for (const child of cellElement.children) {
      firstOrLast += 1;
      // continue only for see more button element
      if (checkForContinue({ firstOrLast })) {
        continue;
      }
      if (child.className.includes("scheduler-event-box")) {
        event += 1;
      }
      const childHeight = child.offsetHeight;
      allChildHeight += childHeight;
    }
    if (cell.maxVisibleEvents < event) {
      cell.maxVisibleEvents = event;
    }
    if (containerHeight - allChildHeight - moreBoxHeight >= lastEventHeight) {
      cell.maxVisibleEvents = cell.maxVisibleEvents + 1;
      reCalculate({
        containerHeight,
        allChildHeight: allChildHeight + lastEventHeight,
        moreBoxHeight,
        lastEventHeight,
        cell,
      });
    }
  } else {
    cell.maxVisibleEvents = 2;
  }
};

export const fullOrFistnameKeys = ["staffMembers", "staffFirstName"];

function StaffAvailabilityTab({
  t,
  staffAvailFiltersData,
  staffAvailabilityViewSelectedFromDashBoard,
  currentDateFromDashBoard,
  setCurrentDateFromDashBoard,
  isFromDashBoard = false,
  appliedAgendaTypes,
  appliedViewSettig,
  isEnterpriseFilterActive: dashboardEnterpriseFilter,
}) {
  const ViewSettingFilter = [
    { title: t("title"), type: "title" },
    { title: t("waitingList.clinicName"), type: "officeName" },
    { title: t("dateAndTime"), type: "timeString" },
  ];
  const isFromLeaveDetail = getStorage("IsFromLeaveSchedule");

  let cachedEventFilter = getStorage(
    constants.localStorageKeys.agenda.eventWorkspaceEventFilter,
  );
  cachedEventFilter = cachedEventFilter ? cachedEventFilter : [];
  const enterpriseCache = getStorage(
    constants.localStorageKeys.agenda.staffSchedulerEnterprise,
  );

  const cacheDashBoardFilter = getStorage(
    constants.notes.cache.dashboardFilter,
  );
  const agendaEventFilter = cacheDashBoardFilter?.agenda
    ? cacheDashBoardFilter?.agenda
    : [];

  const [isLoader, setIsLoader] = useState(false);
  const [agenda, setAgenda] = useState(null);
  const agendaTypesRef = useRef(cachedEventFilter ?? []);
  const [agendaTypes, setAgendaTypes] = useState(cachedEventFilter);
  const [selectedAgendaTypes, setSelectedAgendaTypes] =
    useState(cachedEventFilter);
  const [searchValue, setSearchValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [agendaFilter, setAgendaFilter] = useState([]);
  const [viewSettig, setViewSetting] = useState([]);
  const [settingFilter, setSettingFilter] = useState([]);
  const [displaySetting, setDisplaySetting] = useState(ViewSettingFilter);
  const preExpanded = useMemo(() => {
    const values = getStorage(
      constants.accordion.cache.schedulerOfficeStaffAccordion,
    );
    if (values) {
      if (Array.isArray(values)) {
        return values;
      }
    }
    return ["a", "b", "c", "d"];
  }, []);

  const FilterEventsData = [
    { title: t("accountOwner.eventCreatedByYou"), type: 0 },
    { title: t("accountOwner.eventCreatedByOthers"), type: -1 },
    { title: t("accountOwner.eventsNotAccepted"), type: 4 },
    { title: t("accountOwner.shiftCreatedByYou"), type: 8 },
    { title: t("accountOwner.shiftCreatedByOthers"), type: 6 },
    { title: t("accountOwner.shiftNotAccepted"), type: 7 },
    { title: t("accountOwner.busy"), type: 3 },
    { title: t("accountOwner.leaveApproved"), type: 2 },
    { title: t("accountOwner.leavePending"), type: 9 }, // type 9 will be matched with 1 in leave statusId
    { title: t("scheduler.agenda.appointmentTitle"), type: 1 },
  ];
  const {
    commonOwnerData: ownerData,
    effectiveOwnerId: selectedOwnerId,
    profile: { id: currentUserId },
  } = useAccountOwnerCommon();

  let cachedDate = sessionStorage.getItem(constants.staffAvalibilityDate);
  cachedDate = isFromLeaveDetail?.isFromleaveConflict
    ? new Date(isFromLeaveDetail?.startDate)
    : cachedDate
      ? new Date(cachedDate)
      : new Date();
  const [currentDate, onDateChange] = useState(cachedDate);
  useEffect(() => {
    sessionStorage.setItem(constants.staffAvalibilityDate, moment(currentDate));
    setSearchValue("");
  }, [currentDate]);

  const staffAvailabilityView = [
    { id: "4", name: t("scheduler.views.daily") },
    { id: "5", name: t("scheduler.views.weekly") },
    { id: "1", name: t("scheduler.views.monthly") },
    { id: "3", name: t("scheduler.views.dailyList") },
    { id: "2", name: t("scheduler.views.weeklyList") },
  ];

  let setView = sessionStorage.getItem(constants.staffAvalibility)
    ? sessionStorage.getItem(constants.staffAvalibility)
    : staffAvailabilityView[0]?.id; // Default to Daily View
  const [staffAvailabilityViewSelected, setStaffAvailabilityViewSelected] =
    useState(setView);
  const {
    apiOffices,
    setApiOffices,
    apiEmps,
    setApiEmps,
    selectedOfficeFilter,
    setOfficeFilter,
    selectedEmpFilter,
    setEmpFilter,
    setEmployeeList,
    resetFilters,
    appliedOfficeFilter,
    appliedStaffFilter,
    setAppliedOfficeFilter,
    setAppliedStaffFilter,
    selectedRoles,
    setSelectedRoles,
    setUsersList,
  } = staffAvailFiltersData;

  const [isSidebarActive, setSidebarActive] = useState(
    cacheSideBarActive(constants.sidebar.cache.schedulerIsSidebarActive),
  );
  const [resetSearchTrigger, setResetSearchTrigger] = useState(0);

  // Add state for showEnterpriseEvents
  const [showEnterpriseEvents, setShowEnterpriseEvents] = useState(
    enterpriseCache || false,
  );
  // Add state for when the filter is actually applied
  const [isEnterpriseFilterActive, setIsEnterpriseFilterActive] = useState(
    enterpriseCache || false,
  );

  const effectiveEnterpriseFilter = isFromDashBoard
    ? dashboardEnterpriseFilter
    : isEnterpriseFilterActive;

  const [dateRange, setDateRange] = useState(null);

  const {
    isLoading,
    isRefetching,
    isFetching,
    data: monthlyData,
    refetch: refetchAgenda,
    error,
  } = useGetOfficeAgendaMonthly(
    selectedOwnerId,
    dateRange?.startDate,
    dateRange?.endDate,
    apiOffices,
    apiEmps,
    { enabled: selectedOwnerId && dateRange ? true : false },
  );

  useEffect(() => {
    setAgenda(monthlyData?.data);
    setAgendaFilter(monthlyData?.data);
  }, [isLoading, monthlyData]);

  useEffect(() => {
    if (agendaTypes?.length > 0) {
      filterByEvents();
    }
  }, [agenda]);
  useEffect(() => {
    setSearchValue("");
  }, [dateRange]);
  useEffect(() => {
    setSelectedAgendaTypes(agendaTypes);
  }, [agendaTypes]);

  const filterByEvents = () => {
    const updatedAgenda = agenda?.map((item) =>
      filteringMethodForEventShiftOthers(
        agendaTypesRef.current,
        item,
        currentUserId,
      ),
    );
    setAgendaFilter(updatedAgenda);
  };

  const resetAgenda = () => {
    setSearchValue("");
    scrollToElement();
    resetFilters();
    setSelectedRoles([]);
    setResetSearchTrigger((prev) => prev + 1);
    setAgendaFilter(agenda);
    setAgendaTypes([]);
    agendaTypesRef.current = [];
    setStorage(constants.localStorageKeys.agenda.eventWorkspaceEventFilter, []);
    setViewSetting([]);
    setSettingFilter([]);
    setAppliedOfficeFilter([]);
    setAppliedStaffFilter([]);
    setIsEnterpriseFilterActive(false);
    setShowEnterpriseEvents(false);
    setStorage(constants.localStorageKeys.staffAvailablilityFilter, {
      apiOffices: [],
      apiEmps: [],
    });
    setStorage(
      constants.localStorageKeys.agenda.staffSchedulerEnterprise,
      false,
    );
    setStorage(constants.localStorageKeys.agenda.monthlySettingFilter, []);
    setStorage(constants.localStorageKeys.agenda.weeklySettingFilter, []);
  };

  useEffect(() => {
    sessionStorage.setItem(
      constants.staffAvalibility,
      staffAvailabilityViewSelected,
    );

    setDisplaySetting((prev) => {
      if (
        staffAvailabilityViewSelected === "1" ||
        staffAvailabilityViewSelected === "4" ||
        staffAvailabilityViewSelected === "5"
      ) {
        const baseFilter = ViewSettingFilter.filter(
          (item) => !fullOrFistnameKeys.some((res) => res === item.type),
        );
        if (!prev.some((item) => fullOrFistnameKeys.includes(item.type))) {
          return [
            ...baseFilter,
            {
              title: t("scheduler.staffMembersFullName"),
              type: fullOrFistnameKeys[0],
            },
            {
              title: t("scheduler.staffMembersFirstName"),
              type: fullOrFistnameKeys[1],
            },
          ];
        }
        return prev;
      } else {
        return ViewSettingFilter.filter(
          (item) => !fullOrFistnameKeys.some((res) => res === item.type),
        );
      }
    });
    let monthlySettingFilter = getStorage(
      constants.localStorageKeys.agenda.monthlySettingFilter,
    );
    let weeklySettingFilter = getStorage(
      constants.localStorageKeys.agenda.weeklySettingFilter,
    );
    let settingFilter =
      staffAvailabilityViewSelected === "1"
        ? monthlySettingFilter
        : weeklySettingFilter;
    settingFilter = settingFilter?.length > 0 ? settingFilter : [];
    setViewSetting(settingFilter);
    setSettingFilter(settingFilter);
    setSearchValue("");
  }, [staffAvailabilityViewSelected]);

  const getEmployeeList = async (id) => {
    setIsLoader(true);
    try {
      let res = await getStaffMembersList(selectedOwnerId, id);
      res && setEmployeeList(res.data);
    } catch (error) {
      toast.error(error.message);
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (selectedOwnerId) {
      getEmployeeList(apiOffices || []);
      setSearchValue("");
    }
  }, [selectedOwnerId]);

  const scrollToElement = () => {
    const element = document.getElementById("targetElementId");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
  };

  const handleSidebarToggle = () => {
    setSidebarActive(!isSidebarActive);
    localStorage.setItem(
      constants.sidebar.cache.schedulerIsSidebarActive,
      !isSidebarActive,
    );
  };

  // Add a function to filter monthly agenda
  const filterMonthlyAgenda = () => {
    if (!monthlyData?.data) return [];
    if (!selectedAgendaTypes?.length) return monthlyData.data;

    return monthlyData.data.map((item) =>
      filteringMethodForEventShiftOthers(
        agendaTypesRef.current,
        item,
        currentUserId,
      ),
    );
  };

  const hasFullOrFirstName = useCallback(
    (applied, added = true) =>
      applied?.some((res) =>
        added
          ? fullOrFistnameKeys.includes(res)
          : !fullOrFistnameKeys.includes(res),
      ),
    [],
  );

  const applyFilter = () => {
    scrollToElement();
    setSearchValue("");
    setApiOffices(selectedOfficeFilter);
    setApiEmps(selectedEmpFilter);
    setAppliedOfficeFilter(selectedOfficeFilter);
    setAppliedStaffFilter(selectedEmpFilter);
    setStorage(constants.localStorageKeys.staffAvailablilityFilter, {
      apiOffices: selectedOfficeFilter,
      apiEmps: selectedEmpFilter,
    });
    if (isMobileTab()) {
      handleSidebarToggle();
    }

    // Set the enterprise filter active state when apply is clicked
    setIsEnterpriseFilterActive(showEnterpriseEvents);
    setStorage(
      constants.localStorageKeys.agenda.staffSchedulerEnterprise,
      showEnterpriseEvents,
    );

    // Only apply agendaTypes on Apply
    setAgendaTypes(selectedAgendaTypes);
    agendaTypesRef.current = selectedAgendaTypes;
    if (staffAvailabilityViewSelected === "1") {
      // Monthly
      const filtered = filterMonthlyAgenda();
      setAgendaFilter(filtered);
      setStorage(
        constants.localStorageKeys.agenda.eventWorkspaceEventFilter,
        selectedAgendaTypes,
      );
    } else {
      if (selectedAgendaTypes?.length > 0) {
        filterByEvents();
        setStorage(
          constants.localStorageKeys.agenda.eventWorkspaceEventFilter,
          selectedAgendaTypes,
        );
      } else {
        setAgendaFilter(agenda);
        setStorage(
          constants.localStorageKeys.agenda.eventWorkspaceEventFilter,
          selectedAgendaTypes,
        );
      }
    }

    if (viewSettig?.length > 0) {
      setSettingFilter((prev) => {
        let updatedTypes = viewSettig;

        if (
          staffAvailabilityViewSelected === "1" ||
          staffAvailabilityViewSelected === "4" ||
          staffAvailabilityViewSelected === "5"
        ) {
          updatedTypes = viewSettig;
        } else {
          updatedTypes = viewSettig.filter(
            (type) => !fullOrFistnameKeys.includes(type),
          );
        }

        return updatedTypes;
      });

      if (hasFullOrFirstName(viewSettig)) {
        const weeklyData = hasFullOrFirstName(viewSettig, false);
        setStorage(
          constants.localStorageKeys.agenda.weeklySettingFilter,
          weeklyData,
        );
      } else {
        setStorage(
          constants.localStorageKeys.agenda.weeklySettingFilter,
          viewSettig,
        );
      }
      let monthlySettingFilter = getStorage(
        constants.localStorageKeys.agenda.monthlySettingFilter,
      );
      if (
        hasFullOrFirstName(viewSettig, false) &&
        hasFullOrFirstName(monthlySettingFilter)
      ) {
        setStorage(constants.localStorageKeys.agenda.monthlySettingFilter, [
          ...viewSettig,
          ...fullOrFistnameKeys,
        ]);
      } else {
        setStorage(
          constants.localStorageKeys.agenda.monthlySettingFilter,
          viewSettig,
        );
      }
    } else {
      setSettingFilter([]);
      setStorage(
        constants.localStorageKeys.agenda.weeklySettingFilter,
        viewSettig,
      );
      setStorage(
        constants.localStorageKeys.agenda.monthlySettingFilter,
        viewSettig,
      );
    }
  };

  const isFilterApply =
    appliedOfficeFilter?.length ||
    appliedStaffFilter?.length ||
    cachedEventFilter?.length ||
    settingFilter?.length;

  useEffect(() => {
    if (isFromDashBoard) {
      scrollToElement();
      setAgendaTypes(appliedAgendaTypes);
      agendaTypesRef.current = appliedAgendaTypes;
      setSettingFilter(appliedViewSettig);
    }
  }, [appliedAgendaTypes, appliedViewSettig]);

  const dateChange = (type) => {
    let changeDate =
      staffAvailabilityViewSelected === "2" ||
      staffAvailabilityViewSelected === "5"
        ? "week"
        : staffAvailabilityViewSelected === "1"
          ? "month"
          : "day";
    let date = null;
    if (
      staffAvailabilityViewSelected === "2" ||
      staffAvailabilityViewSelected === "5"
    ) {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(
              moment(currentDate).subtract(1, changeDate).startOf("week"),
            )
          : new Date(moment(currentDate).add(1, changeDate).startOf("week"));
    } else if (staffAvailabilityViewSelected === "1") {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(
              moment(currentDate).subtract(1, changeDate).startOf("month"),
            )
          : new Date(moment(currentDate).add(1, changeDate).startOf("month"));
    } else {
      date =
        type === constants.arrow.PREVIOUS
          ? new Date(moment(currentDate).subtract(1, changeDate).startOf("day"))
          : new Date(moment(currentDate).add(1, changeDate).startOf("day"));
    }

    date && onDateChange(date);
  };

  const onActiveStartDateChange = (value) => {
    if (
      constants.calanderActions.includes(value?.action) ||
      (value?.action === constants.calanderActionKey.drillDown &&
        (value?.view === "month" || value?.view === "year"))
    ) {
      value?.activeStartDate && onDateChange(value.activeStartDate);
    }
  };
  const { dailyActive, monthlyActive, weeklyActive } = useMemo(
    () => ({
      dailyActive: isFromDashBoard
        ? staffAvailabilityViewSelectedFromDashBoard === "1"
        : staffAvailabilityViewSelected === "3",
      weeklyActive: isFromDashBoard
        ? staffAvailabilityViewSelectedFromDashBoard === "2"
        : staffAvailabilityViewSelected === "2",
      monthlyActive: isFromDashBoard
        ? staffAvailabilityViewSelectedFromDashBoard === "3"
        : staffAvailabilityViewSelected === "1",
    }),
    [
      isFromDashBoard,
      staffAvailabilityViewSelected,
      staffAvailabilityViewSelectedFromDashBoard,
    ],
  );
  const hideForDashboard = !isFromDashBoard;
  const isfromLeaveDetailScreen = isFromDashBoard
    ? false
    : isFromLeaveDetail?.isFromleaveConflict;
  const { data } = useAllActiveOffices(
    1,
    constants.OFFICE_PAGE_SIZE_100,
    {
      includeOwnerOffices: true,
      ownerId: selectedOwnerId,
    },
    "",
    { enabled: !!selectedOwnerId },
  );
  const canShowOfficeName = useMemo(() => data?.data?.length > 1, [data?.data]);
  return (
    <div
      className={
        isFromDashBoard
          ? `${styles.dynamic_height} scheduler-tabs-main-wrapper m-0 h-100`
          : "scheduler-tabs-main-wrapper"
      }
    >
      {isLoader && <Loader />}
      {hideForDashboard && !isfromLeaveDetailScreen && (
        <StickySidebar
          isSidebarActive={isSidebarActive}
          handleSidebarToggle={handleSidebarToggle}
          resetFilter={resetAgenda}
        >
          <SchedulerCalendar
            value={currentDate}
            onChange={onDateChange}
            onActiveStartDateChange={onActiveStartDateChange}
            activeStartDate={currentDate}
            showTodayButton={true}
            onTodayClick={() => {
              onDateChange(new Date());
            }}
          />
          <div className="mb-4">
            <span className={styles.notes_filter}>
              {t("notes.filters")}
              {!!isFilterApply && <span className={styles.red_dot}></span>}
            </span>
            <ul className={["filter-list"]}>
              <li>
                <div className="ch-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={showEnterpriseEvents}
                      onChange={(e) =>
                        setShowEnterpriseEvents(e.target.checked)
                      }
                    />{" "}
                    <span> {t("showEnterpriseEvents")}</span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <Accordion
            preExpanded={preExpanded}
            className="filter-accordion"
            allowZeroExpanded
            allowMultipleExpanded
            onChange={(e) => {
              setStorage(
                constants.accordion.cache.schedulerOfficeStaffAccordion,
                e,
              );
            }}
          >
            <AccordionItem uuid="a">
              <AccordionItemHeading>
                <AccordionItemButton>{t("offices")}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <OfficeFilter
                  getEmployeeList={getEmployeeList}
                  selectedOffice={selectedOfficeFilter}
                  setOfficeFilter={setOfficeFilter}
                  selectedOwnerId={selectedOwnerId}
                  includeOwnerOffices
                />
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="b">
              <AccordionItemHeading>
                <AccordionItemButton>
                  {t("accountOwner.staff")}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <EmployeesFilter
                  selectedEmpFilter={selectedEmpFilter}
                  setEmpFilter={setEmpFilter}
                  ownerId={selectedOwnerId}
                  ownerData={ownerData || {}}
                  selectedOfficeFilter={selectedOfficeFilter}
                  selectedRoles={selectedRoles}
                  setSelectedRoles={setSelectedRoles}
                  setUsersList={setUsersList}
                  resetSearchTrigger={resetSearchTrigger}
                />
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="c">
              <AccordionItemHeading>
                <AccordionItemButton>{t("Event/Shift")}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <AgendaFilter
                  setAgendaTypes={setSelectedAgendaTypes}
                  agendaTypes={selectedAgendaTypes}
                  FilterEventsData={FilterEventsData}
                />
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="d">
              <AccordionItemHeading>
                <AccordionItemButton>
                  {t("accountOwner.viewSetting")}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <AgendaFilter
                  setAgendaTypes={setViewSetting}
                  agendaTypes={viewSettig}
                  FilterEventsData={displaySetting}
                />
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <div className="filter-btn-box filter-btn-box--sticky-footer ">
            <button
              className={"button button-round button-shadow mr-3"}
              title={t("apply")}
              onClick={() => applyFilter()}
            >
              {" "}
              {t("apply")}
            </button>
            <button
              className={
                "button button-round button-border button-dark reset-btn"
              }
              onClick={resetAgenda}
              title={t("reset")}
            >
              {t("reset")}
            </button>
            <button
              className={
                "button button-round button-border button-dark cancel-btn"
              }
              title={t("close")}
              onClick={handleSidebarToggle}
            >
              {t("close")}
            </button>
          </div>
        </StickySidebar>
      )}
      <div
        className={
          isFromDashBoard ? "tabs-right-col p-0 h-100" : "tabs-right-col"
        }
        id="targetElementId"
      >
        {isfromLeaveDetailScreen && (
          <Text
            backgroundColor="#FCC539"
            padding="11px 20px"
            size="14px"
            weight="400"
            color="#000000"
            marginBottom="8px"
            borderRadius="6px"
          >
            Leave requested by <strong>{isFromLeaveDetail?.userName} </strong>{" "}
            for{" "}
            <strong>
              {moment(isFromLeaveDetail?.startDate).format("MMM DD, YYYY")}
            </strong>{" "}
            to{" "}
            <strong>
              {moment(isFromLeaveDetail?.endDate).format("MMM DD, YYYY")}{" "}
            </strong>
          </Text>
        )}
        {hideForDashboard && (
          <div className={eventStyles["event-shift-header"]}>
            <div className={eventStyles["search-form-calc"]}>
              <ExpandableSearchBar
                placeholder={t(
                  "accountOwner.searchPlaceholderForStaffScheduleTitle",
                )}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                isFocused={isFocused}
                setIsFocused={setIsFocused}
              />
            </div>
            <div className="d-flex">
              <div className="monthly-calendar-arrows">
                {staffAvailabilityViewSelected && (
                  <>
                    <div
                      className="arrow-img"
                      onClick={() => dateChange(constants.arrow.PREVIOUS)}
                    >
                      <img
                        src={
                          require("assets/images/monthly-arrow-left.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </div>

                    <div className="monthly-calendar-text">
                      {staffAvailabilityViewSelected === "1" &&
                        moment(currentDate).format("MMM YYYY")}
                      {(staffAvailabilityViewSelected === "2" ||
                        staffAvailabilityViewSelected === "5") && (
                        <>
                          {`${moment(currentDate)
                            .startOf("week")
                            .format("ddd, MMM DD")} - ${moment(currentDate)
                            .endOf("week")
                            .format("ddd, MMM DD")} `}
                        </>
                      )}
                      {staffAvailabilityViewSelected === "4" &&
                        moment(currentDate).format("ddd, MMM DD, YYYY")}
                      {staffAvailabilityViewSelected === "3" &&
                        moment(currentDate).format("ddd, MMM DD, YYYY")}
                    </div>
                    <div
                      className="arrow-img"
                      onClick={() => dateChange(constants.arrow.NEXT)}
                    >
                      <img
                        src={
                          require("assets/images/monthly-arrow-right.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </div>
                  </>
                )}
              </div>
              <CustomDropdown
                options={staffAvailabilityView}
                selectedOption={staffAvailabilityViewSelected}
                selectOption={setStaffAvailabilityViewSelected}
              />
            </div>
          </div>
        )}
        {hideForDashboard && (
          <div className={styles["staff-availability-header"]}>
            <ul className={styles["view-color-list"]}>
              <li>
                <div className={styles["color-box"]} />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.createdByYou")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-grey"]}
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.createdByOthers")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-blue"]}
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.eventsNotAccepted")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-orange"]}
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("accountOwner.busy")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={
                    styles["color-box"] +
                    " " +
                    schedulerStyles[
                      leaveClasses(constants.agendaType.PENDINGLEAVE).main
                    ]
                  }
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("scheduler.agenda.pendingLeave")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={
                    styles["color-box"] +
                    " " +
                    schedulerStyles[
                      leaveClasses(constants.agendaType.APPROVEDLEAVE).main
                    ]
                  }
                />
                <div className={styles["text-box"]}>
                  {" "}
                  {t("scheduler.agenda.approvedLeave")}{" "}
                </div>
              </li>
              <li>
                <div
                  className={
                    styles["color-box"] + " " + styles["light-purple-bg"]
                  }
                />
                <div className={styles["text-box"]}> {t("appointments")} </div>
              </li>
              <li>
                <div
                  className={styles["color-box"] + " " + styles["color-green"]}
                />
                <div className={styles["text-box"]}> {t("staff.holiday")} </div>
              </li>
            </ul>
          </div>
        )}
        {dailyActive ? (
          <DailyViewNew
            currentUserId={currentUserId}
            selectedOwnerId={selectedOwnerId}
            apiOffices={apiOffices}
            apiEmps={apiEmps}
            isSidebarActive={isSidebarActive}
            agendaTypes={agendaTypes}
            viewSettingFilter={settingFilter}
            isDaily={true}
            searchValue={searchValue}
            currentDate={
              isFromDashBoard ? currentDateFromDashBoard : currentDate
            }
            onDateChange={
              isFromDashBoard ? setCurrentDateFromDashBoard : onDateChange
            }
            cachedEventFilter={
              isFromDashBoard ? agendaEventFilter : cachedEventFilter
            }
            isFromDashBoard={isFromDashBoard}
            isEnterpriseFilterActive={effectiveEnterpriseFilter}
            isfromLeaveDetailScreen={isfromLeaveDetailScreen}
            isFromLeaveDetail={isFromLeaveDetail}
            canShowOfficeName={canShowOfficeName}
          />
        ) : weeklyActive ? (
          <StaffAvailabilityWeeklyView
            currentDate={
              isFromDashBoard ? currentDateFromDashBoard : currentDate
            }
            selectedOwnerId={selectedOwnerId}
            currentUserId={currentUserId}
            apiOffices={apiOffices}
            apiEmps={apiEmps}
            searchValue={searchValue}
            onDateChange={onDateChange}
            isSidebarActive={isSidebarActive}
            isWeekly={true}
            agendaTypes={agendaTypes}
            cachedEventFilter={
              isFromDashBoard ? agendaEventFilter : cachedEventFilter
            }
            viewSettingFilter={settingFilter}
            isFromDashBoard={isFromDashBoard}
            isEnterpriseFilterActive={effectiveEnterpriseFilter}
            isfromLeaveDetailScreen={isfromLeaveDetailScreen}
            isFromLeaveDetail={isFromLeaveDetail}
            canShowOfficeName={canShowOfficeName}
          />
        ) : !isFromDashBoard && staffAvailabilityViewSelected === "5" ? (
          <WeeklyListView
            currentDate={
              isFromDashBoard ? currentDateFromDashBoard : currentDate
            }
            selectedOwnerId={selectedOwnerId}
            currentUserId={currentUserId}
            apiOffices={apiOffices}
            apiEmps={apiEmps}
            searchValue={searchValue}
            agendaTypes={agendaTypes}
            cachedEventFilter={
              isFromDashBoard ? agendaEventFilter : cachedEventFilter
            }
            viewSettingFilter={settingFilter}
            isEnterpriseFilterActive={effectiveEnterpriseFilter}
            isFreeStotLoading={isLoading || isRefetching || isFetching}
            canShowOfficeName={canShowOfficeName}
            onDateChange={onDateChange}
          />
        ) : !isFromDashBoard && staffAvailabilityViewSelected === "4" ? (
          <DailyListView
            currentDate={
              isFromDashBoard ? currentDateFromDashBoard : currentDate
            }
            selectedOwnerId={selectedOwnerId}
            currentUserId={currentUserId}
            apiOffices={apiOffices}
            apiEmps={apiEmps}
            searchValue={searchValue}
            agendaTypes={agendaTypes}
            cachedEventFilter={
              isFromDashBoard ? agendaEventFilter : cachedEventFilter
            }
            viewSettingFilter={settingFilter}
            isEnterpriseFilterActive={effectiveEnterpriseFilter}
            isFreeStotLoading={isLoading || isRefetching || isFetching}
            canShowOfficeName={canShowOfficeName}
            onDateChange={onDateChange}
          />
        ) : monthlyActive ? (
          <MonthlyViewNew
            currentDate={
              isFromDashBoard ? currentDateFromDashBoard : currentDate
            }
            selectedOwnerId={selectedOwnerId}
            currentUserId={currentUserId}
            onDateChange={onDateChange}
            setDateRange={setDateRange}
            agendaTypes={agendaTypes}
            isLoading={isLoading || isRefetching || isFetching}
            searchValue={searchValue}
            agenda={agendaFilter}
            viewSettingFilter={settingFilter}
            error={error}
            isEnterpriseFilterActive={effectiveEnterpriseFilter}
            isFromDashBoard={isFromDashBoard}
            isfromLeaveDetailScreen={isfromLeaveDetailScreen}
            isFromLeaveDetail={isFromLeaveDetail}
            canShowOfficeName={canShowOfficeName}
            onAgendaUpdate={() => {
              refetchAgenda();
            }}
          />
        ) : null}
      </div>
    </div>
  );
}

export default withTranslation()(StaffAvailabilityTab);
